import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsEmployeeWorkdays from 'graphql/fields/FieldsEmployeeWorkdays'

const fields = {
	'workday_day': 'Int',
	'workday_start': 'String',
	'workday_end': 'String',
};

export default gql(`
	mutation employee_workday( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_workday( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsEmployeeWorkdays}
	    }
	}
`);

